import React from 'react';
import CallReportPage from '../components/reports/CallReportPage';

const TenderCallReport: React.FC = () => <CallReportPage title="Tender Call Report" reportType="tender" />;

export default TenderCallReport;

